import { connect } from 'react-redux';
import { fetchDataSamples, fetchCharacteristics, loadDataSet } from 'js/actions';
import { getSamplesForDataSet, getAccessToken } from 'js/reducers/selectors';
import {
  GET_DATA_SAMPLES_REQUEST,
  GET_DATA_CHARACTERISTICS_REQUEST,
} from 'js/constants/actionTypes';

import DataSetDataBrowser from './DataSetDataBrowser';

const mapStateToProps = (state, ownProps) => {
  const { request, dataSetSchemas } = state;
  const { data } = ownProps;

  return {
    isLoadingSamples: !!(
      request[GET_DATA_SAMPLES_REQUEST] || request[GET_DATA_CHARACTERISTICS_REQUEST]
    ),
    dataSetSchema: data ? dataSetSchemas[data.id] : null,
    dataSetSamples: getSamplesForDataSet(state, ownProps),
    accessToken: getAccessToken(state),
  };
};

export default connect(mapStateToProps, {
  fetchDataSamples,
  fetchCharacteristics,
  loadDataSet,
})(DataSetDataBrowser);
